import { Resource } from 'src_common/common/mobx-utils/Resource';
import { ApiListSettingsResponse200Type } from 'src/api_openapi/v2/settingsService/apiListSettings';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { Common } from 'src/AppState/Common';
import { action, makeObservable, observable } from 'src_common/common/mobx-wrapper';

export class ConfigurationManagerState {
    public readonly services: Resource<ApiListSettingsResponse200Type['data']>;
    @observable public currentServiceId: string | null = null;

    public static get = AutoWeakMap.create((_common: Common) => new ConfigurationManagerState());

    private constructor() {
        this.services = new Resource(async (): Promise<ApiListSettingsResponse200Type['data']> => {
            const response = await $appState.sdkStaff.settingsService.getAllServices();
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (response.status === 200) {
                return response.body.data;
            }
            throw new Error(`ConfigurationManagerState Api Error ${JSON.stringify(response, null, 2)}`);
        });

        makeObservable(this);
    }

    @action public setCurrentServiceId = (serviceId: string): void => {
        this.currentServiceId = serviceId;
    };
}
